/* N2 Collection — テーマの JS。
   原則: 無くても買えること。ここでやっているのは、手数を減らすことだけ。
   （書類のような見た目にしているので、動きで飾ることはしない） */
(function () {
  "use strict";

  var reduced = window.matchMedia
    && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* 導入演出の後始末。**消すのは CSS の役目**で、ここは保険。
     アニメーションが走らない環境で覆いが残ると、サイトが見えなくなる。 */
  var splash = document.querySelector(".splash");
  var video = document.querySelector(".hero-video");

  /* 動きを減らす設定なら動画を止める。**CSS で隠すだけでは再生は続く**ので、
     見えないところで通信と再生が走り続けることになる。 */
  if (video && reduced) {
    video.autoplay = false;
    video.pause();
  }

  if (splash) {
    window.setTimeout(function () {
      if (splash.parentNode) { splash.parentNode.removeChild(splash); }
      /* 演出が消えた時点で動画を頭に戻す。**演出の裏で再生が進んでいる**ので、
         そのままだと途中から見え始める。autoplay は付けたままなので、
         ここが動かなくても再生自体は続く。 */
      if (video && !reduced) {
        try {
          video.currentTime = 0;
          var played = video.play();
          if (played && played.catch) { played.catch(function () {}); }
        } catch (e) { /* 再生できない環境では poster のままにする */ }
      }
    }, 5000);
  }

  /* 節が現れる動き。

     **隠すのも戻すのもインラインで当てる。** CSS 側に置くと、当たったかどうかが
     詳細度と読み込み順に左右される。

     **必ず出す保険を付けてある。** 監視が動かない・条件を満たさないなど、
     何かの理由で戻し損ねると中身が永久に見えない。装飾のための動きで
     そこまでの risk を負う意味が無いので、時間切れで全部戻す。

     組み立ては読み込み完了後。監視は登録直後に一度判定が走るが、画像の寸法が
     決まる前だとページが短く、下にある節まで「見えている」と判定されうる。 */
  var targets = document.querySelectorAll("[data-reveal]");
  if (targets.length && !reduced && "IntersectionObserver" in window) {
    var hidden = [];
    var show = function (el) {
      el.style.opacity = "";
      el.style.transform = "";
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        show(e.target);
        io.unobserve(e.target);   /* 一度出したら監視をやめる（戻ると消えるのは邪魔） */
      });
    }, { rootMargin: "0px 0px -12% 0px" });

    var arm = function () {
      Array.prototype.forEach.call(targets, function (t) {
        /* その時点で既に見えているものは触らない。
           画面の高い端末で隠すと「読み込んだのに中身が無い」瞬間を作る。 */
        if (t.getBoundingClientRect().top < window.innerHeight * 0.9) { return; }
        t.style.opacity = "0";
        t.style.transform = "translateY(.75rem)";
        t.style.transition = "opacity .7s ease, transform .7s ease";
        hidden.push(t);
        io.observe(t);
      });
      /* 保険。8秒あれば普通は読まれている。ここで残っていたら出す */
      window.setTimeout(function () {
        hidden.forEach(function (t) { show(t); io.unobserve(t); });
      }, 8000);
    };
    if (document.readyState === "complete") { arm(); }
    else { window.addEventListener("load", arm, { once: true }); }
  }

  /* 絞り込み: チェックした時点で送る。「絞り込む」を押させると1手増える。
     JS が無い環境では noscript の送信ボタンが出るので、機能自体は失われない。 */
  var form = document.getElementById("filter-form");
  if (form) {
    form.addEventListener("change", function () { form.submit(); });
  }

  /* 並べ替えは絞り込みフォームの外にあるが、送信は同じフォームに乗せる
     （別々に送ると、片方の条件が消える） */
  var sort = document.querySelector("[data-sort]");
  if (sort && form) {
    sort.addEventListener("change", function () {
      var hidden = form.querySelector('input[name="sort_by"]');
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "sort_by";
        form.appendChild(hidden);
      }
      hidden.value = sort.value;
      form.submit();
    });
  }

  /* 絞り込みの開閉: 広い画面では常に開く。狭い画面では畳む。
     開いたまま置くと、商品が2画面ぶん下に押し出される。 */
  var box = document.getElementById("filters");
  if (box) {
    var wide = window.matchMedia("(min-width: 60em)");
    var apply = function () { box.open = wide.matches; };
    apply();
    wide.addEventListener("change", apply);
  }

  /* バリアントの選択: 選択肢の組み合わせから該当バリアントを選ぶ。
     選択肢が1つ（既定バリアントのみ）の商品では何もしない。 */
  var variantSelect = document.querySelector("[data-variant-select]");
  var optionSelects = document.querySelectorAll("[data-variant-option]");
  if (variantSelect && optionSelects.length) {
    var sync = function () {
      var chosen = [];
      optionSelects.forEach(function (el) { chosen.push(el.value); });
      var want = chosen.join(" / ");
      for (var i = 0; i < variantSelect.options.length; i++) {
        if (variantSelect.options[i].text.trim() === want) {
          variantSelect.selectedIndex = i;
          return;
        }
      }
    };
    optionSelects.forEach(function (el) { el.addEventListener("change", sync); });
  }

  /* お問い合わせフォーム: 種別で欄を出し入れする（/pages/contact）。
     `data-topic` の値と select の値が一致した要素だけを出す。

     **JS が無ければ全部出る。** 隠すのは手数を減らすためだけで、
     「隠れているせいで送れない」状態を作らない。 */
  var topic = document.getElementById("contact-topic");
  if (topic) {
    var groups = document.querySelectorAll("[data-topic]");
    var applyTopic = function () {
      var v = topic.value;
      Array.prototype.forEach.call(groups, function (g) {
        var on = g.getAttribute("data-topic") === v;
        g.hidden = !on;
        /* **隠した欄は disabled にする。** 理由が2つある。
           1. 見えない必須項目が残ると、ブラウザが「入力してください」と言うのに
              その欄が画面に無い。原因が分からないまま送れなくなる
           2. disabled な欄は送信されないので、届くメールに空の項目が並ばない
           （`required` を外すだけでは 2 が残る） */
        Array.prototype.forEach.call(
          g.querySelectorAll("input, select, textarea"),
          function (el) { el.disabled = !on; }
        );
      });
    };
    topic.addEventListener("change", applyTopic);
    applyTopic();
  }
})();
